function numberToWords(number: number): string {
  const oneToTwenty: string[] = [
    '',
    'one ',
    'two ',
    'three ',
    'four ',
    'five ',
    'six ',
    'seven ',
    'eight ',
    'nine ',
    'ten ',
    'eleven ',
    'twelve ',
    'thirteen ',
    'fourteen ',
    'fifteen ',
    'sixteen ',
    'seventeen ',
    'eighteen ',
    'nineteen ',
  ];

  const tenth: string[] = [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
  ];

  if (number.toString().length > 7) return 'overflow';

  const num: RegExpMatchArray | null = `0000000${number}`
    .slice(-7)
    .match(/^(\d{1})(\d{1})(\d{2})(\d{1})(\d{2})$/);

  if (!num) return '';

  let outputText =
    Number(num[1]) !== 0
      ? `${
          oneToTwenty[Number(num[1])] ||
          `${tenth[Number(num[1][0])]} ${oneToTwenty[Number(num[1][1])]}`
        }million `
      : '';

  outputText +=
    Number(num[2]) !== 0
      ? `${
          oneToTwenty[Number(num[2])] ||
          `${tenth[Number(num[2][0])]} ${oneToTwenty[Number(num[2][1])]}`
        }hundred `
      : '';

  outputText +=
    Number(num[3]) !== 0
      ? `${
          oneToTwenty[Number(num[3])] ||
          `${tenth[Number(num[3][0])]} ${oneToTwenty[Number(num[3][1])]}`
        }thousand `
      : '';

  outputText +=
    Number(num[4]) !== 0
      ? `${
          oneToTwenty[Number(num[4])] ||
          `${tenth[Number(num[4][0])]} ${oneToTwenty[Number(num[4][1])]}`
        }hundred `
      : '';

  outputText +=
    Number(num[5]) !== 0
      ? oneToTwenty[Number(num[5])] ||
        `${tenth[Number(num[5][0])]} ${oneToTwenty[Number(num[5][1])]} `
      : '';

  return outputText.trim();
}

export default numberToWords;
